import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { ModalController, NavController } from "@ionic/angular";
import { ApiService } from "@core/services/api/api.service";

@Component({
  selector: "app-notification-modal",
  templateUrl: "./notification-modal.component.html",
  styleUrls: ["./notification-modal.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class NotificationModalComponent implements OnInit {
  gaugeType = "semi";
  gaugeValue;
  gaugeLabel;
  gaugeAppendText = "km/hr";
  private subs = null;

  constructor(public modalController: ModalController, private navController: NavController, public api: ApiService) {
    this.subs = this.api.get("people/status").subscribe((data) => {
      const numItems = Object.keys(data.data).length - 2; // 1 is added bec. of the complete field.
      data.data.complete = data.data.complete - 1;
      if (data.data.complete === numItems && data.data.wizard_completed) {
        this.dismiss();
      } else {
        this.gaugeLabel = data.data.complete + "/7";
        this.gaugeValue = ((data.data.complete / 7) * 100).toFixed(0);
      }
    });
  }

  ngOnInit() {
    // this.api.get('people/status').subscribe(data => {
    //   this.gaugeLabel = data.data.complete + "/7"
    //   console.log(this.status);
    // });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  dismiss() {
    this.modalController.dismiss();
  }

  goToWizard() {
    this.modalController.dismiss().then(() => {
      this.navController.navigateRoot("/dashboard/wizard");
    });
  }
}
